import { Button, Card, Col, Form, Input, notification, Row, Space, Tabs } from "antd";
import React, { useContext, useEffect } from "react";
import SearchInput from "../../components/SearchInput";
import IntegrationTab from "./components/IntegrationTab";
import { useParams, useSearchParams } from "react-router-dom";
import { requestGetProfile } from "../../services/user.service";
import AppContext from "../../store/app.context";
import TeamSettings from "./components/TeamSettings";
import UserSettings from "./components/UserSettings";

const SettingPage = () => {
	const { teamId } = useParams();

	if (teamId) {
		return <TeamSettings teamId={teamId} />;
	} else {
		return <UserSettings />;
	}
};

export default SettingPage;
